import { render, staticRenderFns } from "./TaskMoreDetails.vue?vue&type=template&id=6d35805d"
import script from "./TaskMoreDetails.vue?vue&type=script&lang=js"
export * from "./TaskMoreDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports